import React from "react";
import { useIntl } from "react-intl";

import { form } from "../../../messages";
import {
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
} from "@material-ui/core";
import FieldTranslation from "../../../components/FieldTranslation";

export default function NameMultilang({
  values,
  handleChange,
  availableLanguages = [],
  valuesLng = {},
  defaultLanguage = "",
  handleValuesLng,
}) {
  const intl = useIntl();

  return (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel>{intl.formatMessage(form.name)}</InputLabel>
        <Input
          type="text"
          value={values.name}
          name="name"
          onChange={handleChange("name")}
          endAdornment={
            <InputAdornment position="end">
              <FieldTranslation
                language={defaultLanguage}
                items={valuesLng.name}
                availableLanguages={availableLanguages}
                onChange={handleValuesLng && handleValuesLng("name")}
                title={intl.formatMessage(form.name)}
              />
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  );
}
